
export interface MetricWithTrend {
  value: number;
  trend: 'up' | 'down' | 'none';
  percentChange: number;
}

export interface NewsItem {
  title: string;
  link: string;
  pubDate?: string;
  date?: string;
  source?: string;
  lang?: 'en' | 'pl';
}

export interface LeakItem {
  domain: string;
  breach_date: string;
  data_leaked: string;
  data_leaked_pl?: string;
  leak_count?: number;
  description?: string;
  description_pl?: string;
}

export interface VulnerabilityItem {
  id: string;
  name: string;
  description?: string;
  description_pl?: string;
  score: number;
  publishedDate: string;
}

export interface EOLItem {
  name: string;
  cycle: string;
  eol: string;
  daysRemaining: number;
}

export interface ReleaseItem {
  nazwa_projektu: string;
  wersja: string;
  data_wydania: string;
  url_projektu: string;
  url_zdjecia: string;
}

export interface RansomwareItem {
  victim: string;
  group: string;
  attackdate: string;
  domain: string;
  country: string;
}

export interface DashboardData {
  eolItemsCount: MetricWithTrend;
  leaksCount: MetricWithTrend;
  mostActiveRansomwareGroup: string;
  mostAttackedCountry: string;
  ransomwareVictimsCount: MetricWithTrend;
  criticalVulnerabilitiesCount: MetricWithTrend;
  highVulnerabilitiesCount: MetricWithTrend;
  mediumVulnerabilitiesCount: MetricWithTrend;
  lowVulnerabilitiesCount: MetricWithTrend;
  latestNews?: NewsItem[];
  allNews?: NewsItem[];
  recentLeaks?: LeakItem[];
  recentCriticalVulnerabilities?: VulnerabilityItem[];
  recentHighVulnerabilities?: VulnerabilityItem[];
  recentMediumVulnerabilities?: VulnerabilityItem[];
  recentLowVulnerabilities?: VulnerabilityItem[];
  upcomingEOL?: EOLItem[];
  latestReleases?: ReleaseItem[];
  allReleases?: ReleaseItem[];
  recentRansomwareAttacks?: RansomwareItem[];
  allRansomwareAttacks?: RansomwareItem[];
}

export const defaultDashboardData: DashboardData = {
  eolItemsCount: { value: 15, trend: 'none', percentChange: 0 },
  leaksCount: { value: 17, trend: 'none', percentChange: 0 },
  mostActiveRansomwareGroup: "LockBit",
  mostAttackedCountry: "USA",
  ransomwareVictimsCount: { value: 23, trend: 'none', percentChange: 0 },
  criticalVulnerabilitiesCount: { value: 8, trend: 'none', percentChange: 0 },
  highVulnerabilitiesCount: { value: 26, trend: 'none', percentChange: 0 },
  mediumVulnerabilitiesCount: { value: 54, trend: 'none', percentChange: 0 },
  lowVulnerabilitiesCount: { value: 112, trend: 'none', percentChange: 0 },
  latestNews: [],
  allNews: [],
  recentLeaks: [],
  recentCriticalVulnerabilities: [],
  recentHighVulnerabilities: [],
  recentMediumVulnerabilities: [],
  recentLowVulnerabilities: [],
  upcomingEOL: [],
  latestReleases: [],
  allReleases: [],
  recentRansomwareAttacks: [],
  allRansomwareAttacks: []
};
